import { Component, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, map } from 'rxjs/operators';
import { FilterOperations } from 'src/app/filters/filter-operation/filter-operations.enum';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { UsersFilterOption } from '../../models/users-filter-option';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-account-user-register',
    templateUrl: './account-user-register.component.html',
    standalone: false
})
export class AccountUserRegisterComponent {
   filters: UsersFilterOption[];

   constructor(public store: Store) {
      store
         .select(getSelectedAccountId)
         .pipe(
            filter((accountId: number | null): accountId is number => {
               return accountId != null;
            }),
            map((accountId: number) => {
               const filters: UsersFilterOption[] = [
                  {
                     field: 'AccountId',
                     operation: FilterOperations.EqualTo,
                     type: 'numeric',
                     value: accountId,
                  },
               ];
               return filters;
            })
         )
         .subscribe((filters) => {
            this.filters = filters;
         });
   }
}
